export default __webpack_public_path__ + "static/media/Reenviar-acuses.4bcda994.svg";